import React, { useState } from 'react';
import { mockData } from './data';
import * as LucideIcons from 'lucide-react';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { FilesDrilldown } from './FilesDrilldown';
export function PointsBreakdownTable() {
  const [activeMetric, setActiveMetric] = useState<string | null>(null);
  const positiveMetrics = mockData.performance.filter(m => !m.isPenalty);
  return <>
      <motion.section initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.4,
      delay: 0.3
    }} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden h-full flex flex-col" data-id="element-336">
        <div className="px-5 py-3 border-b border-gray-200 flex items-center justify-between bg-white" data-id="element-337">
          <h2 className="text-sm font-bold text-[#0A1F5C] uppercase tracking-wide" data-id="element-338">
            Points Breakdown (Month to Date)
          </h2>
          <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider hidden sm:inline" data-id="element-339">
            Click row to view files
          </span>
        </div>

        <div className="overflow-x-auto flex-1" data-id="element-340">
          <table className="w-full text-left border-collapse" data-id="element-341">
            <thead data-id="element-342">
              <tr className="bg-gray-50 border-b border-gray-200" data-id="element-343">
                <th className="px-5 py-3 text-[10px] font-bold text-gray-500 uppercase tracking-wider" data-id="element-344">
                  Metric
                </th>
                <th className="px-3 py-3 text-[10px] font-bold text-gray-500 uppercase tracking-wider text-center" data-id="element-345">
                  Per Action
                </th>
                <th className="px-3 py-3 text-[10px] font-bold text-gray-500 uppercase tracking-wider text-center" data-id="element-346">
                  Count
                </th>
                <th className="px-3 py-3 text-[10px] font-bold text-gray-500 uppercase tracking-wider text-right" data-id="element-347">
                  Earned
                </th>
                <th className="px-3 py-3 text-[10px] font-bold text-gray-500 uppercase tracking-wider text-right" data-id="element-348">
                  Max Potential
                </th>
                <th className="px-3 py-3 w-6" data-id="element-349"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-350">
              {positiveMetrics.map(metric => {
              // @ts-ignore
              const Icon = LucideIcons[metric.icon] || LucideIcons.HelpCircleIcon;
              return <tr key={metric.id} onClick={() => setActiveMetric(metric.id)} className="group hover:bg-gray-50 transition-colors cursor-pointer" data-id="element-351">
                    <td className="px-5 py-4" data-id="element-352">
                      <div className="flex items-center gap-3" data-id="element-353">
                        <div className={`w-9 h-9 rounded-full ${metric.color} text-white flex items-center justify-center shrink-0`} data-id="element-354">
                          <Icon className="w-4 h-4" data-id="element-355" />
                        </div>
                        <div className="min-w-0" data-id="element-356">
                          <div className="text-xs font-bold text-[#0A1F5C] uppercase tracking-wide" data-id="element-357">
                            {metric.title}
                          </div>
                          <div className="text-[10px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-358">
                            {metric.subtitle}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="px-3 py-4 text-center" data-id="element-359">
                      {metric.isSpeed ? <div className={`text-[10px] font-bold ${metric.textColor} whitespace-pre-line leading-tight`} data-id="element-360">
                          {metric.rate}
                        </div> : <span className={`text-xs font-bold ${metric.textColor}`} data-id="element-361">
                          {metric.rate}
                        </span>}
                    </td>
                    <td className="px-3 py-4 text-center" data-id="element-362">
                      <span className="text-sm font-bold text-[#0A1F5C] tabular-nums" data-id="element-363">
                        {metric.count}
                      </span>
                      <span className="text-[10px] text-gray-500 ml-1 uppercase tracking-wider" data-id="element-364">
                        Files
                      </span>
                    </td>
                    <td className="px-3 py-4 text-right" data-id="element-365">
                      <span className={`text-lg font-bold tabular-nums ${metric.textColor}`} data-id="element-366">
                        {metric.points}
                      </span>
                    </td>
                    <td className="px-3 py-4 text-right" data-id="element-367">
                      <div className="flex flex-col items-end leading-tight" data-id="element-368">
                        <span className={`text-sm font-bold tabular-nums ${metric.textColor}`} data-id="element-369">
                          {metric.maxPoints}
                        </span>
                        <span className="text-[10px] text-gray-500 font-medium" data-id="element-370">
                          ({metric.maxCount})
                        </span>
                      </div>
                    </td>
                    <td className="px-3 py-4 text-right" data-id="element-371">
                      <ChevronRightIcon className="w-4 h-4 text-gray-300 group-hover:text-[#0A1F5C] transition-colors" data-id="element-372" />
                    </td>
                  </tr>;
            })}
            </tbody>
            <tfoot className="bg-gray-50 border-t-2 border-gray-200" data-id="element-373">
              <tr data-id="element-374">
                <td colSpan={3} className="px-5 py-4 text-[10px] font-bold text-[#0A1F5C] uppercase tracking-wider" data-id="element-375">
                  Total Points Earned
                </td>
                <td className="px-3 py-4 text-right" colSpan={3} data-id="element-376">
                  <span className="text-2xl font-bold text-[#0A1F5C] tabular-nums" data-id="element-377">
                    {mockData.monthly.points}
                  </span>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </motion.section>

      <FilesDrilldown metricId={activeMetric} onClose={() => setActiveMetric(null)} data-id="element-378" />
    </>;
}